angular.module('nv.routes.errors').factory('AuthenticationRequiredError', authenticationRequiredError);

function authenticationRequiredError(UtilitiesService) {
  function AuthenticationRequiredError(message) {
    let temp = Error.apply(this, arguments);
    temp.name = this.name = 'AuthenticationRequiredError';
    this.stack = temp.stack;
    this.message = message || '';
  }

  UtilitiesService.inherits(AuthenticationRequiredError, Error);

  return AuthenticationRequiredError;
}
